export const Admin = () => (
  <p>
    “Some humans would do anything to see if it was possible to do it. If you
    put a large switch in some cave somewhere, with a sign on it saying
    ‘End-of-the-World Switch. PLEASE DO NOT TOUCH,’ the paint wouldn't even have
    time to dry.”
  </p>
)
